import {useState} from "react";
import {useQuery} from "react-query";
import axios from "services/axios";
import qs from "query-string";

async function getReviews(id, filter) {
	if (!id) {
		const {data} = await axios.get(`/reviews`, {params: {...filter, sortBy: "id.desc"}});

		return data;
	}
	const {data} = await axios.get(`/reviews/${id}`);

	return data;
}

export const QUERY = "review";
export function useListReview(filter) {
	return useQuery([QUERY, filter], () => axios.get(`/reviews/?${qs.stringify(filter)}`).then(res => res.data));
}

export function useReview() {
	const [filter, filterReviews] = useState({
		page: 1,
		search: null,
		limit: 10,
	});
	const [reviewId, reviewById] = useState(null);
	const fallback = [];
	const {
		data = fallback,
		isLoading,
		isError,
		error,
	} = useQuery(["review", filter, reviewId], async () => getReviews(reviewId, filter));

	return {data, isLoading, isError, error, filter, filterReviews, reviewById};
}

export const fetchReview = reviewId => {
	return axios.get(`reviews/${reviewId}`).then(res => res.data);
};

export function useDetailReview(reviewId) {
	return useQuery({
		queryKey: reviewId && ["review", reviewId],
		queryFn: key => fetchReview(reviewId),
		refetchOnMount: false,
		refetchOnWindowFocus: false,
		enabled: !!reviewId,
	});
}
